/* eslint-disable */
// @ts-nocheck

import { useContext, useEffect } from 'react'

import useServerProduct from '../../../api/useServerProducts'
import ProductTypeBadge from '../../../components/misc/badges/ProductTypeBadge'
import GenericTable, {
  DataTableInterface,
} from '../../../components/misc/GenericTable'
import ImageComponent from '../../../components/misc/Images/Image'
import { translateMeasure } from '../../../utils/translate'
import { DetailProductContext } from '../DetailProductContainer'

const Dependencies = () => {
  const { product } = useContext(DetailProductContext)
  const { getProductDependencies, dependencies, isLoading } = useServerProduct()
  useEffect(() => {
    product?.id && getProductDependencies(product.id)
  }, [])

  //Data for table -------------------------------------------------------------
  const tableTitles = ['Producto', 'Tipo', 'Cantidad', 'Unidad de medida']
  const tableData: DataTableInterface[] =
    dependencies.map((item) => ({
      rowId: item.id,
      payload: {
        Producto: (
          <div className="inline-flex items-center gap-2">
            <ImageComponent
              className="h-10 w-10 rounded-full"
              hash={item?.images[0]?.blurHash}
              src={item?.images[0]?.src}
            />
            <p>{item.name}</p>
          </div>
        ),
        Tipo: <ProductTypeBadge type={item.type} />,
        Cantidad: item.quantity,
        'Unidad de medida': translateMeasure(item.measure),
      },
    })) ?? []

  //-----------------------------------------------------------------------------
  return (
    <div className="h-[34rem] overflow-auto rounded-md border border-slate-300 p-5 pr-5 scrollbar-thin scrollbar-thumb-slate-300">
      <GenericTable
        loading={isLoading}
        tableData={tableData}
        tableTitles={tableTitles}
      />
    </div>
  )
}

export default Dependencies
